<div class="password-validation" >
    <div class="password-strength">
        <ul class="password-strength-bar">
            <li class="ps-bar-0" [ngClass]="getStrengthLevelClass()"><span></span></li>
            <li class="ps-bar-1" [ngClass]="getStrengthLevelClass()"><span></span></li>
            <li class="ps-bar-2" [ngClass]="getStrengthLevelClass()"><span></span></li>
        </ul>
    </div>
    <div class="password-suggestion" >
        <span [hidden]="password.length >= PASSWORD_LENGTH_REQUIRED">Password must contain at least {{PASSWORD_LENGTH_REQUIRED}} characters.</span>
    </div>
</div>
